import React, { useState } from "react";
import styled from "styled-components/macro";
import { MonitorBox } from "./MonitorBox";
import { UnitBox } from "./UnitBox";
import tuluUnitLogo from "../../images/unit/tuluUnitLogo.png";
import { AddUnitBox } from "./AddUnitBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { UnitBoxDraw } from "./UnitBox_Draw";
import { Arrow } from "./Arrows/Arrow";
import { RoomUnitSizeHeight } from "./room_unit_size_height";

import { WiresArrowLeft, WiresArrowRight } from "./Arrows/WiresArrows";

export const currencySymbolByLocation = (newLocation) => {
  switch (newLocation) {
    case "us":
      return "$";
    case "eu":
      return "€";
    case "uk":
      return "£";
    case "il":
      return "₪";
    default:
      return "us";
  }
};

const RoomUnit = ({
  columns,
  colorUnit,
  logoImage,
  itemsCount,
  onRemovePress,
  onUpPress,
  onDownPress,
  onAddItemPress,
  onRemoveColumnPress,
  setUnitScale,
  unitScale,
  onAddColumnPress,
  setShowAddColumnOnHover,
  showAddColumnOnHover,
  isDraw = false,
  location,
  isPDF,
  isCarpenter,
  isSticker,
  isWires,
  isElectric,
}) => {
  const [popupItem, setPopupItem] = useState();
  const isCM = location !== "us";

  // top shelf division

  let firstShelf;
  let secondShelf;

  if (columns.length === 2 || columns.length === 3 || columns.length === 4) {
    firstShelf = 100;
    secondShelf = 0;
  } else {
    if (columns.length === 6 || columns.length === 8) {
      firstShelf = 49.9;
      secondShelf = 49.9;
    } else {
      if (columns.length === 5) {
        firstShelf = 59.9;
        secondShelf = 39.9;
      } else {
        if (columns.length === 7) {
          firstShelf = 42.8;
          secondShelf = 57.1;
        }
      }
    }
  }

  function BottomSizes() {
    return (
      isDraw && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ display: "flex", flexDirection: "row" }}>
            {_renderBottomSizes()}
          </div>
          <div
            style={{
              display: "flex",
              borderLeft: "1px solid grey",
              borderRight: "1px solid grey",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Arrow size={columns.length * 94} side={"left"} />
            <BottomSizeUnitText>
              {isCM
                ? columns.length * 50 + (columns.length - 1) * 1.5
                : columns.length * 20 + (columns.length - 1) * 0.5}
            </BottomSizeUnitText>
            <Arrow size={columns.length * 94} side={"right"} />
          </div>
        </div>
      )
    );
  }
  let count = 0;
  let monitor = false;
  const _renderColumns = () => {
    return columns?.map((column, columnIndex) => {
      let columnsTotal = 0;

      return (
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "row",
            boxShadow: isDraw ? null : "0px 6px 10px #bababa",
          }}
          key={columnIndex}
        >
          <div style={{ position: "absolute" }}>
            {!isElectric &&
              isWires &&
              columnIndex !== 0 &&
              columnIndex !== columns.length - 1 && <Wire />}
            {!isElectric && isWires && columnIndex === 0 && (
              <>
                <WiresArrowLeft />
                <WiresArrowRight />
              </>
            )}
          </div>
          <DividerVertical
            isDraw={isDraw}
            frameColor={colorUnit}
            isEdge={columnIndex === 0 || columnIndex === columns.length}
          />
          <div>
            {column?.map((item, index) => {
              count++;

              columnsTotal = columnsTotal + item?.cellSize;
              if (!item) return null;

              if (item.type === "monitor") {
                monitor = true;
                return (
                  <MonitorBox
                    isWires={isWires}
                    isSticker={isSticker}
                    isCarpenter={isCarpenter}
                    isDraw={isDraw}
                    key={index}
                    frameColor={colorUnit}
                    popupItem={popupItem}
                    colorUnit={colorUnit}
                    logo={logoImage}
                    isElectric={isElectric}
                  />
                );
              }
              // UnitBox

              const Component = isDraw ? UnitBoxDraw : UnitBox;

              return (
                <Component
                  key={index + "component"}
                  count={count}
                  isFirst={columnIndex === 0}
                  isCarpenter={isCarpenter}
                  isSticker={isSticker}
                  isWires={isWires}
                  isElectric={isElectric}
                  colorUnit={colorUnit}
                  item={item}
                  isBottom={index === column.length - 1}
                  isTop={
                    index === 0 ||
                    (columnIndex === 0 && index === 1 && monitor === true)
                  }
                  quantity={itemsCount[item.id]}
                  onRemovePress={
                    onRemovePress
                      ? () => onRemovePress({ columnIndex, index })
                      : null
                  }
                  popupItem={popupItem}
                  onUpPress={
                    onUpPress
                      ? () => {
                          onUpPress({ columnIndex, index });
                        }
                      : null
                  }
                  onDownPress={
                    onDownPress
                      ? () => {
                          onDownPress({ columnIndex, index });
                        }
                      : null
                  }
                  onPopupClose={setPopupItem ? () => setPopupItem(null) : null}
                  onPopupOpen={setPopupItem ? () => setPopupItem(item) : null}
                />
              );
            })}

            {columnsTotal < 7 && (
              <div>
                <AddUnitBox
                  onRemoveColumnPress={onRemoveColumnPress}
                  colorUnit={colorUnit}
                  size={7 - columnsTotal}
                  onAddItemPress={!isDraw && onAddItemPress}
                  columnsLength={columns.length}
                  columnIndex={columnIndex}
                />
              </div>
            )}
          </div>
          <DividerVertical
            isDraw={isDraw}
            frameColor={colorUnit}
            isEdge={columnIndex === columns.length - 1}
          />
          {columns.length - 1 !== columnIndex && (
            <DividerVertical
              style={{
                backgroundImage: isDraw
                  ? null
                  : "linear-gradient(to bottom, white, white)",
                width: "5px",
                border: isDraw ? "1px solid black" : null,
              }}
              isDraw={isDraw}
            />
          )}

          {onAddColumnPress && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                position: "absolute",
                top: 0,
                bottom: 0,
                right: -18,
                zIndex: 10,
                opacity: showAddColumnOnHover === columnIndex ? 1 : 0,
              }}
              onMouseEnter={
                setShowAddColumnOnHover
                  ? () => setShowAddColumnOnHover(columnIndex)
                  : null
              }
              onMouseLeave={
                setShowAddColumnOnHover
                  ? () => setShowAddColumnOnHover(-1)
                  : null
              }
            >
              <FontAwesomeIcon
                size={"2x"}
                color={"#2b2b2b"}
                onClick={() => onAddColumnPress({ columnIndex })}
                style={{
                  padding: "5px",
                  margin: "auto",
                  cursor: "pointer",
                }}
                icon={faPlusCircle}
              />
            </div>
          )}
        </div>
      );
    });
  };

  const _renderBottomSizes = () => {
    return columns?.map((column, columnIndex) => {
      return (
        <BottomSizeUnit
          key={columnIndex}
          lastBox={columnIndex === columns.length - 1}
        >
          <BottomSizeUnitText>{isCM ? "50" : "20"}.00</BottomSizeUnitText>
        </BottomSizeUnit>
      );
    });
  };

  const _renderUpperSizes = () => {
    return columns?.map((column, columnIndex) => {
      return (
        <div
          key={`Column ${columnIndex + 1}`}
          style={{
            display: "flex",
            position: "relative",
            flexDirection: "column",
          }}
        >
          <UpperSizeUnit
            firstBox={columnIndex === 0}
            lastBox={columnIndex === columns.length - 1}
          >
            <BottomSizeUnitText>{`Column ${
              columnIndex + 1
            }`}</BottomSizeUnitText>
          </UpperSizeUnit>

          {columnIndex === 1 && (
            <DoorSizeUnit>
              <TopSizeUnitText>{`Open Door`}</TopSizeUnitText>
              <DoorSizeUnitHandle />
              <DoorSizeUnitWood />

              <div
                style={{
                  position: "absolute",
                  right: "-90px",
                  top: 0,
                  bottom: 0,
                }}
              >
                <MiddleBox>
                  <Arrow side={"up"} size={85} />
                  <ArrowText>{isCM ? "49" : "19.5"}</ArrowText>
                  <Arrow side={"down"} size={85} />
                </MiddleBox>
              </div>
            </DoorSizeUnit>
          )}
        </div>
      );
    });
  };
  const [, setTranslateUnitY] = useState(0);

  const wrapperRef = React.useRef();

  React.useEffect(() => {
    let wrapperWidth = wrapperRef.current.getBoundingClientRect().width;

    const wrapperHeight = wrapperRef.current.getBoundingClientRect().height;

    const screenWidth = window.innerWidth - 60;
    const theScale = screenWidth / wrapperWidth;
    const newHeight = wrapperHeight * theScale;

    if (setUnitScale && wrapperWidth > screenWidth) {
      setUnitScale(screenWidth / wrapperWidth);

      setTranslateUnitY(newHeight - wrapperHeight);
      return;
    }
  }, [setUnitScale, wrapperRef]);

  const ViewTitle = styled.div`
    font-size: 28px;
    margin-top: -51px;
    margin-bottom: 12px;
    width: 1365px;
  `;

  return (
    <div
      ref={wrapperRef}
      className="UnitScaleContainer"
      style={{
        transform: unitScale && `scale(${unitScale})`,
        transformOrigin: "top",
      }}
    >
      <WrapperUnit isDraw={isDraw}>
        {isDraw && !isCarpenter && <ViewTitle>Front View</ViewTitle>}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: 1500,
            justifyContent: !isDraw && "center",
          }}
        >
          {isDraw && (
            <InnerWrapper>
              <Line isPDF={isPDF} />
              <Arrow side={"up"} size={400} />
              <ArrowText style={{ margin: "20px 0px" }}>
                {isCM ? "200" : "80.25"}
              </ArrowText>
              <Arrow side={"down"} size={348} />
              <Line isPDF={isPDF} />
            </InnerWrapper>
          )}
          <div style={{ display: "flex", flexDirection: "column" }}>
            {
              <Top>
                <Shelf
                  width={firstShelf}
                  isDraw={isDraw}
                  frameColor={colorUnit}
                  color={colorUnit}
                >
                  {isDraw ? (
                    <TuluDrawLogo>T U L U</TuluDrawLogo>
                  ) : (
                    <TuluUnitLogo src={tuluUnitLogo} />
                  )}
                </Shelf>
                <Shelf
                  width={secondShelf}
                  isDraw={isDraw}
                  frameColor={colorUnit}
                  color={colorUnit}
                ></Shelf>
              </Top>
            }
            <Unit>{_renderColumns()}</Unit>
            <BottomShelf
              isDraw={isDraw}
              style={{ width: "100%" }}
              frameColor={colorUnit}
              height={30}
            />
            <BottomSizes />
            {/*מבט על*/}
          </div>

          {isDraw && <div style={{ width: "10px" }} />}
          {isDraw && !isCarpenter && (
            <div>
              {" "}
              <ViewTitle style={{ marginLeft: 12 }}>Side View</ViewTitle>
              <RoomUnitSizeHeight isCM={isCM} />
            </div>
          )}
        </div>
        {isDraw && !isCarpenter && (
          <div
            style={{
              display: "flex",
              width: 1500,
              flexDirection: "column",
              marginTop: "70px",
            }}
          >
            {" "}
            <ViewTitle style={{ marginLeft: 65 }}>Top View</ViewTitle>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <InnerWrapper style={{ height: 203 }}>
                <Line isPDF={isPDF} />
                <Arrow side={"up"} size={85} />
                <ArrowText style={{ margin: "12px 0px" }}>
                  {isCM ? "50" : "20"}
                </ArrowText>
                <Arrow side={"down"} size={90} />
                <Line isPDF={isPDF} />
              </InnerWrapper>

              {_renderUpperSizes()}
            </div>
          </div>
        )}
      </WrapperUnit>
    </div>
  );
};

const Line = styled.div`
  width: 100px;
  height: 1px;
  border-bottom: ${(props) => (props.isPDF ? 2 : 1)}px solid grey;
`;
const DividerVertical = styled.div`
  width: 10px;
  box-shadow: ${({ isDraw }) => (isDraw ? null : "0 0 1px #4a4a4a")};
  border: ${({ isDraw, isEdge }) =>
    isDraw ? (isEdge ? "3px solid black" : "1px solid black") : null};
  background: ${({ frameColor, isDraw }) => {
    return isDraw ? null : frameColor;
  }};
`;
const WrapperUnit = styled.div`
  transform: scale(0.7);
  transform-origin: top;
  position: relative;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-bottom: 5px;
  margin-bottom: -200px;
`;

const Unit = styled.div`
  z-index: 999;
  display: flex;
  position: relative;
  flex-direction: row;
`;

const TuluUnitLogo = styled.img`
  padding: 5px;
  margin-left: 30px;
  object-fit: contain;
  width: 150px;
`;
const Top = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Shelf = styled.div`
  display: flex;
  position: relative;
  height: ${({ height = 70 }) => height}px;
  width: ${(props) => props.width}%;
  border-radius: 2px;
  z-index: 99999999;
  box-shadow: ${({ isDraw }) =>
    isDraw ? null : "0 3px 6px 0 rgba(0, 0, 0, 0.16)"};
  border: ${({ isDraw }) => (isDraw ? "3px solid black" : null)};
  background: ${({ frameColor, isDraw }) => {
    return isDraw ? null : frameColor;
  }};
`;
const TuluDrawLogo = styled.p`
  color: #a8a7a7;
  font-size: 40px;
  margin-bottom: 0;
  margin-left: 30px;
  align-items: center;
  display: flex;
`;
const BottomShelf = styled.div`
  display: flex;
  position: relative;
  height: ${({ height = 70 }) => height}px;
  width: 100%;
  border-radius: 2px;
  //z-index: 9999;
  background: ${({ frameColor, isDraw }) => {
    return isDraw ? null : frameColor;
  }};
  box-shadow: ${({ isDraw }) => (isDraw ? null : "-2px 1px 20px -8px #4a4a4a")};
  border: ${({ isDraw }) => (isDraw ? "3px solid black" : null)};
`;

const BottomSizeUnit = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 100px;
  border: 1px solid grey;
  border-bottom: 0;
  border-right-width: ${({ lastBox }) => (lastBox ? "1px" : 0)};
  align-items: center;
  justify-content: center;
  justify-items: center;
`;

const UpperSizeUnit = styled.div`
  display: flex;
  position: relative;
  width: 204px;
  height: 204px;
  border-radius: 2px;
  border-top: 3px solid black;
  border-bottom: 3px solid black;
  border-left: ${({ firstBox }) =>
    firstBox ? "3px solid black" : "1px solid grey"};
  border-right: ${({ lastBox }) =>
    lastBox ? "3px solid black" : "1px solid grey"};

  align-items: center;
  justify-content: center;
  justify-items: center;
`;

const DoorSizeUnit = styled.div`
  display: flex;
  position: relative;
  width: 204px;
  height: 204px;
  border-bottom-left-radius: 204px;
  border: 1px dashed darkgrey;
  border-top-width: 0;
  align-items: center;
  justify-content: center;
  justify-items: center;
`;

const DoorSizeUnitHandle = styled.div`
  display: flex;
  position: absolute;
  width: 20px;
  height: 45px;
  border: 1px solid darkgrey;
  border-left-width: 0;
  bottom: 0;
  right: -20px;
`;
const DoorSizeUnitWood = styled.div`
  display: flex;
  position: absolute;
  width: 8px;
  border: 0 solid darkgrey;
  border-left-width: 1px;
  bottom: 0;
  top: 0;
  right: 0;
`;

const BottomSizeUnitText = styled.p`
  display: flex;
  position: relative;
  flex: 1;
  text-align: center;
  margin: 0px 8px;
  justify-content: center;
  color: #808080;
  font-size: 22px;
`;
const TopSizeUnitText = styled.p`
  display: flex;
  position: relative;
  flex: 1;
  text-align: center;
  justify-content: center;
  color: #808080;
  font-size: 22px;
  margin-bottom: 15px;
  margin-left: 15px;
`;

const ArrowText = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  color: #a1a0a0;

  align-items: center;
`;

const MiddleBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 60px;
  align-items: center;
  justify-content: center;
  color: #808080;
  font-size: 20px;
  height: 200px;
`;

const InnerWrapper = styled.div`
  position: relative;
  height: 760px;
  width: 60px;
  display: flex;
  flex-direction: column;
`;
const Wire = styled.div`
  border-top: 2px solid red;
  position: absolute;
  top: -15px;
  width: 225px;
`;

export { RoomUnit };
